import AccordionGroup from "@mui/joy/AccordionGroup"
import Accordion from "@mui/joy/Accordion"
import AccordionDetails from "@mui/joy/AccordionDetails"
import AccordionSummary from "@mui/joy/AccordionSummary"
import styles from "./FaqSection.module.css"

type Questions = {
  title: string
  content: string
}
type FaqProps = {
  questions: Questions[]
}

const FaqSection = ({ questions }: FaqProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2rem",
        color: "var(--Morado-Fiva, #401C72)",
        margin: "4rem 0rem 0rem 0rem",
      }}
    >
      <AccordionGroup
        sx={{
          width: "100%",
          maxWidth: {
            xs: "90%",
            sm: "40rem",
            md: "40rem",
            lg: "60rem",
            xl: "80rem",
          },
        }}
        size="lg"
      >
        <h2 className={styles.title}>Nosotros te respondemos</h2>

        {questions?.map((question, index) => (
          <Accordion
            key={index}
            sx={{
              borderBottom: "1px solid var(--Aguamarina-Fiva, #00F5EA)",
              "&:last-child": {
                borderBottom: 0,
              },
              "&:before": {
                display: "none",
              },
              "& .MuiAccordionSummary-root": {
                color: "var(--Morado-Fiva, #401C72)",
                "&:hover": {
                  backgroundColor: "inherit",
                },
              },
              "& .MuiAccordionDetails-root": {
                color: "var(--Morado-Fiva, #401C72)",
                padding: "2rem 0rem",
              },
              "& .MuiAccordionSummary-root:hover, .MuiButtonBase-root:hover": {
                color: "var(--Morado-Fiva, #401C72)",
              },
            }}
          >
            <AccordionSummary
              className={styles.AccordionSummary}
              sx={{
                fontSize: {
                  xs: "1.125rem",
                  sm: "1.25rem",
                  md: "1.25rem",
                  lg: "1.25rem",
                  xl: "1.25rem",
                },
              }}
            >
              <span
                style={{
                  color: "var(--Morado-Fiva, #401C72)",
                  fontWeight: "700",
                  margin: "0.25rem 0rem",
                }}
              >
                {question.title}
              </span>
            </AccordionSummary>
            <AccordionDetails>{question.content}</AccordionDetails>
          </Accordion>
        ))}
      </AccordionGroup>
    </div>
  )
}

export default FaqSection
